import { useCallback } from "react";
import { useMainStore } from "../../../core/store/mainStore";

/**
 * The forms a patient link names in its `fids` parameter, replacing whatever the previous patient left in the
 * persisted store of this shared device. Set directly rather than through a Firestore listener: the link routes are
 * unauthenticated and practiceForms requires a signed-in user.
 */
export const useApplyLinkFormState = () => {
  const setPracticeFormIdsArray = useMainStore((state) => state.setPracticeFormIdsArray);
  const setCurrentPracticeFormIndex = useMainStore((state) => state.setCurrentPracticeFormIndex);
  const setCurrentPracticePatientForm = useMainStore((state) => state.setCurrentPracticePatientForm);
  return useCallback(
    (fids: string | null | undefined) => {
      setCurrentPracticePatientForm(undefined);
      setPracticeFormIdsArray(fids ? fids.split("_").map((id, index) => ({ id, index })) : undefined);
      setCurrentPracticeFormIndex(0);
    },
    [setCurrentPracticePatientForm, setPracticeFormIdsArray, setCurrentPracticeFormIndex],
  );
};
